import React from 'react';

const Industries: React.FC = () => {
  const industries = [
    {
      icon: '🏪',
      title: 'Tiendas y Comercios',
      subtitle: 'Al por menor'
    },
    {
      icon: '🏢',
      title: 'Operaciones',
      subtitle: 'Mayoristas'
    },
    {
      icon: '🔧',
      title: 'Proveedores',
      subtitle: 'De servicios'
    },
    {
      icon: '🌐',
      title: 'Empresas',
      subtitle: 'Multi-ubicación'
    }
  ];

  return (
    <section className="industries">
      <div className="container">
        <div className="section-header">
          <h2>Industrias que Atendemos</h2>
          <p>Perfecto para empresas colombianas que requieren</p>
        </div>
        <div className="industries-grid">
          {industries.map((industry, index) => (
            <div key={index} className="industry-card">
              <div className="industry-icon">{industry.icon}</div>
              <h3>{industry.title}</h3>
              <p>{industry.subtitle}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Industries;